export default __webpack_public_path__ + "static/media/submit_order_no_2.69d4495c.svg";